import Quill from '../core/quill';
import Module from '../core/module';
import Tweet from '../blots/tweet';
import Delta from 'quill-delta';

class Twitter extends Module {
  constructor(...args) {
    super(...args);
    
    this.quill.clipboard.addMatcher('tweet', node => {
      if (node.dataset && node.dataset.url) {
        return new Delta().insert({tweet: node.dataset.url});
      }
      return new Delta();
    });
  }
  
  static register() {
    Quill.register(Tweet);
  }
}

export default Twitter;
